
import { Vue, Component } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import DetailDialog from '@/components/busi/table/detail.vue'
import DictSelect from '@/components/busi/custom/dictselect.vue'
import util from '@/utils/busi/util'
import { gradeSearch, gradeDetail } from '@/api/baseinformation'
@Component({
  name: 'grade-manage',
  components: {
    SimpleTable,
    DetailDialog,
    DictSelect
  }
})
export default class GradeManage extends Vue {
  private form = {
    gradeState: 1
  }

  private loading = !1

  private tableData = {
    list: [],
    totalCount: 0
  }

  private columns = [{
    prop: 'gradeCode',
    label: '年级代码'
  },
  {
    prop: 'gradeName',
    label: '年级名称'
  },
  {
    prop: 'gradeState',
    label: '状态'
  }]

  private pagination: any = {
    currentPage: 1,
    pageSize: 10
  }

  private async onQuery (pagination: any = null) {
    // do something
    this.loading = !0
    const form = util.trimForm(this.form)
    !pagination && (this.pagination.currentPage = 1)
    await gradeSearch({
      ...form,
      ...pagination || this.pagination
    }).then((res: any) => {
      this.loading = !1
      this.tableData.list = res.object.list
      this.tableData.totalCount = res.object.totalCount
    }).catch((err: any) => {
      console.log('err', err)
      this.loading = !1
    })
  }

  private onReset () {
    this.form = {
      gradeState: 1
    }
    this.onQuery()
  }

  private visible = !1

  private detailData = {}

  private async showDetail (row: any) {
    await gradeDetail({ id: row.id }).then((res: any) => {
      if (res.code === 10000) {
        this.visible = !0
        this.detailData = {
          gradeCode: res.object.gradeCode,
          gradeName: res.object.gradeName,
          gradeState: res.object.gradeState
        }
      }
    })
  }

  mounted () {
    this.onQuery()
  }
}
